const NrcSearch = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
  >
    <path
      d="M24.1898 25.5L15.2648 16.575C14.5564 17.1417 13.7418 17.5903 12.821 17.9208C11.9002 18.2514 10.9203 18.4167 9.88143 18.4167C7.30782 18.4167 5.12969 17.5253 3.34705 15.7427C1.56442 13.9601 0.673096 11.7819 0.673096 9.20833C0.673096 6.63472 1.56442 4.4566 3.34705 2.67396C5.12969 0.89132 7.30782 0 9.88143 0C12.455 0 14.6332 0.89132 16.4158 2.67396C18.1984 4.4566 19.0898 6.63472 19.0898 9.20833C19.0898 10.2472 18.9245 11.2271 18.5939 12.1479C18.2634 13.0687 17.8148 13.8833 17.2481 14.5917L26.1731 23.5167L24.1898 25.5ZM9.88143 15.5833C11.6523 15.5833 13.1575 14.9635 14.3971 13.724C15.6366 12.4844 16.2564 10.9792 16.2564 9.20833C16.2564 7.4375 15.6366 5.93229 14.3971 4.69271C13.1575 3.45312 11.6523 2.83333 9.88143 2.83333C8.1106 2.83333 6.60539 3.45312 5.3658 4.69271C4.12622 5.93229 3.50643 7.4375 3.50643 9.20833C3.50643 10.9792 4.12622 12.4844 5.3658 13.724C6.60539 14.9635 8.1106 15.5833 9.88143 15.5833Z"
      fill="#00355E"
    />
  </svg>
);
export default NrcSearch;
